
import { v4 as  uuid } from "uuid";
import Vue from "vue";
import {ExtraArg} from "@/models/script";
import { TranslateResult } from "vue-i18n";
import {ISelectItem} from "winfakt-vue-components";
import {DossierConfigService} from "@/services";

export default Vue.extend({
	data(){
		return {
			id: uuid(),
			selectedTab: 0,
			parsedValue: {
				startMonth: 1,
				endMonth: 12
			}
		};
	},
	props: {
		value: {
			type: String,
			required: true
		},
		label: String,
		arg: {
			type: Object as ()=>ExtraArg,
			required: true
		}
	},
	computed: {
		bookyearStartMonth():number {
			return DossierConfigService.getGeneralConfig().BookYearStartMonth + 1;
		},
		months(): ISelectItem<number>[] {
			const startMonth = this.bookyearStartMonth || 1; // default = januari
			const months = Array.from({ length: 12 }, (_, i) => ((startMonth + i - 1) % 12) + 1);

			return months.map((monthNumber, index) => {
				return {
					text: index+1 + ". " + this.$t("common.months." + monthNumber).toString(),
					value: index + 1, // 1 = startMonth, 12 = maand ervoor
				} as ISelectItem<number>;
			});
		},
		tabs():string[]{
			return [this.$ct("month-range").toString(), this.$ct("quarter-select").toString()];
		},
		startMonth():number{
			return this.parsedValue.startMonth;
		},
		endMonth():number{
			return this.parsedValue.endMonth;
		},
		hasBookYearRangeOption():boolean{
			return this.arg.hasOption("use-bookyear-months");
		}
	},
	watch: {
		value: {
			handler(){
				this.parsedValue = JSON.parse(this.value);
			}
		},
		selectedTab(){
			if (this.selectedTab != 1) return;
			this.setStartMonth(1);
			this.setEndMonth(12);
		}
	},
	methods: {
		onInput(){
			this.$emit("input", JSON.stringify(this.parsedValue));
		},
		setStartMonth(month:number){
			this.parsedValue.startMonth = month;
			this.onInput();
		},
		setEndMonth(month:number){
			this.parsedValue.endMonth = month;
			this.onInput();
		},
		isQuarterSelected(quarter:number):boolean{
			return this.parsedValue.startMonth / 3 == quarter;
		},
		selectQuarter(quarter:number){
			this.parsedValue.startMonth = (((quarter-1)*3)+1);
			this.parsedValue.endMonth = this.parsedValue.startMonth +2;
			this.onInput();
		},
		isYearSelected():boolean{
			return this.parsedValue.startMonth == 1 && this.parsedValue.endMonth == 12;
		},
		selectYear(){
			this.parsedValue.startMonth = 1;
			this.parsedValue.endMonth = 12;
			this.onInput();
		},
		getQuarterLabel(quarter:string):TranslateResult{
			if (this.hasBookYearRangeOption){
				return this.$ct(`bookyear-quarter.${quarter}`);
			}
			return this.$ct(`quarter.${quarter}`);
		}
	},
	created(){
		this.setStartMonth(1);
		this.setEndMonth(12);
	},
	i18nEx: {
		componentPrefix: "components.reportengine"
	}
});
